import { projectManagementRouter } from "@/routers/warehouseSupervision/projectManagement";
import { contractManagementRouter } from "@/routers/warehouseSupervision/contractManagement";
import { warehouseStorageRouter } from "@/routers/warehouseSupervision/storage";
import statementStatisticsRouter from "@/routers/warehouseSupervision/statementStatistics";
import { ROLE_TYPE } from "@supplier/meta";
import { UserStore } from "@/stores/modules/user.ts";

const warehouseSupervisionRouters = [
    {
        path: "/warehouseSupervision",
        name: "WarehouseSupervision",
        meta: {
            title: "仓储业务",
            icon: "icon-a-Frame52",
            hidden: ({ userStore }: { userStore: UserStore }) => {
                // 进销存管理和仓储业务根据企业身份展示，拥有仓储监管企业身份。
                return userStore.isSAAS && !userStore.userInfo.supplier?.roles?.includes(ROLE_TYPE.WAREHOUSE_SUPERVISION.code);
            }
        },
        children: [
            ...projectManagementRouter,
            ...contractManagementRouter,
            ...warehouseStorageRouter,
            ...statementStatisticsRouter
        ]
    }
];
export default warehouseSupervisionRouters;
